import { api } from "@/lib/api";
import {
  LoginCredentials,
  RegisterData,
  AuthResponse,
  User,
} from "@/types/auth.types";

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    try {
      const response = await api.post<AuthResponse>("/auth/login", credentials);
      const authResponse = response.data;

      // Store token and user in localStorage after successful login
      if (authResponse.status === "success" && authResponse.data) {
        if (typeof window !== "undefined") {
          localStorage.setItem("token", authResponse.data.token);
          localStorage.setItem("user", JSON.stringify(authResponse.data.user));
        }
      }

      return authResponse;
    } catch (error: any) {
      // Extract error message from API response
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message || 
        'Invalid email or password';
      
      // Return error response with specific message
      return {
        status: 'error',
        message: errorMessage,
        data: { token: '', user: { id: '', email: '', name: '', role: '' } }
      };
    }
  },

  async logout(): Promise<void> {
    await api.post("/auth/logout").catch(() => {});
    if (typeof window !== "undefined") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  },
};
